import type { StyledComponent } from "@emotion/styled";
import { Box, type BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "LoadingBox";

export const classes = {
  root: `${PREFIX}-root`,
};

export const LoadingBox: StyledComponent<BoxProps> = styled(Box)({
  [`&.${classes.root}`]: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
});
